import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithReauth } from "./baseQuery/baseQueryWithReauth";

interface FastrLoginPayload {
  linkId: string;
  pin: string;
  linkSecret: string;
}
export interface FastrLoginResponse {
  access_token: string;
  token_type: string;
  expires_in: number;
  refresh_token?: string;
}

export const authApi = createApi({
  reducerPath: "authApi",
  baseQuery: baseQueryWithReauth(`${import.meta.env.VITE_APP_YAPI_DOCMGR}`),
  endpoints: (builder) => ({
    loginFastr: builder.mutation<FastrLoginResponse, FastrLoginPayload>({
      query: (body) => ({
        url: "/api/v1/fastr/oauth/login",
        method: "POST",
        body,
      }),
    }),
    logoutFastr: builder.mutation<void, void>({
      query: () => ({
        url: "/api/v1/fastr/oauth/logout",
        method: "POST",
      }),
    }),
  }),
});

export const { useLoginFastrMutation, useLogoutFastrMutation } = authApi;
